export default __webpack_public_path__ + "static/media/location.3f1cb126.svg";